// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import { type Node } from 'react';

const Styles = {
  main: props => {
    return {
      color: Colors.deepSpace,
      display: props.isBlock ? 'block' : undefined,
      fontWeight: 600,
      marginBottom: props.isBlock ? 5 : undefined,
    };
  },
};

type Props = {
  children: Node,
  htmlFor: string,
  isBlock: boolean,
};

const InputLabel = (props: Props) => {
  return (
    <label css={Styles.main(props)} htmlFor={props.htmlFor}>
      {props.children}
    </label>
  );
};

export default InputLabel;
